import React from 'react';
import iconify from '../iconify';

const AnonymousUserIcon = ({customColor, ...props}) => (
  <svg
    width="1em"
    height="1em"
    viewBox="5737.874 1331.101 23.416 26.75"
    {...props}
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#d3793b" />
        <stop offset="1" stopColor="#ea4154" />
      </linearGradient>
    </defs>
    <path
      id="Path_290"
      data-name="Path 290"
      fill={customColor ? customColor : 'url(#linear-gradient)'}
      d="M11.727,15.214c3.717,0,6.707-3.6,6.707-8.048C18.433,2.951,15.674,0,11.727,0S4.982,2.951,4.982,7.166C4.982,11.574,8.01,15.214,11.727,15.214Zm0-13.3c2.874,0,4.79,2.108,4.79,5.25,0,3.372-2.146,6.132-4.79,6.132S6.9,10.539,6.9,7.166C6.9,4.024,8.853,1.916,11.727,1.916Zm.69,14.448H11c-6.592,0-11,3.756-11,9.428a.949.949,0,0,0,.958.958.949.949,0,0,0,.958-.958c0-5.557,4.905-7.511,9.083-7.511h1.418c4.177,0,9.083,1.954,9.083,7.511a.958.958,0,0,0,1.916,0C23.416,20.12,19.008,16.364,12.417,16.364Z"
      transform="translate(5737.874 1331.101)"
    />
  </svg>
);

export default iconify(AnonymousUserIcon);
